import dynamic from 'next/dynamic'
import { useState } from 'react'
import Wrap from './../wrap'
import styles from './search.module.scss'

const Select = dynamic(() => import('react-select'))
const colorBorder = '#c5c7c5'

const customTheme = theme => ({
    ...theme,
    borderRadius: 0,
    padding: 20,
    colors: {
        ...theme.colors,
        primary25: '#f6f6f6',
        primary: '#f4ba60',
        primary75: '#f4f4f2',
        primary50: '#f4f4f2',
        neutral5: colorBorder,
        neutral10: colorBorder,
        neutral20: colorBorder,
        neutral30: colorBorder,
        neutral40: colorBorder,
        neutral50: '#232f2a',
        neutral60: '#232f2a',
        neutral70: '#232f2a',
        neutral80: '#232f2a',
        neutral90: '#232f2a'
    }
})

const customStyles = {
    valueContainer: (provided, props) => {
        const { simple } = props.selectProps
        return {
            ...provided,
            padding: simple ? '0px 16px' : '18px 16px 0px 16px'
        }
    },
    singleValue: (provided, props) => {
        const { simple } = props.selectProps
        return {
            ...provided,
            padding: simple ? '0' : '18px 0 0 0'
        }
    },
    control: (provided, props) => {
        const { white } = props.selectProps
        return {
            ...provided,
            boxShadow: 'none',
            background: white ? '#fff' : '#f4f4f2',
            borderWidth: 0,
            outline: 0,
            borderRadius: 9
        }
    },
    indicatorSeparator: () => {
        return {
            display: 'none'
        }
    }
}

export default function Search(props) {
    const [isFocus, setIsFocus] = useState(false)
    const { onChange, name, readOnly, options, value, required, simple, white } = props

    const handleChange = newValue => {
        onChange({ ...newValue, name })
    }

    const valueObject = options.find(option => option.value === value)

    // let useStyles = customStyles
    // useStyles.control = provided => {
    //     return {
    //         ...provided,
    //         borderStyle: 'dashed',
    //         background: '#fff',
    //         borderWidth: 0,
    //         borderRadius: 9
    //     }
    // }

    return (
        <Wrap {...props} isFocus={isFocus} reactSelect>
            <input
                type="text"
                value={value || ''}
                tabIndex="-1"
                autoComplete="off"
                required={required}
                onChange={() => {}}
                className={styles.reactSelectRequired}
            />
            <Select
                simple={simple}
                white={white}
                readOnly={readOnly}
                styles={customStyles}
                theme={customTheme}
                placeholder=""
                isSearchable={1}
                options={options}
                value={valueObject}
                onChange={handleChange}
                onFocus={() => {
                    setIsFocus(true)
                }}
                onBlur={() => {
                    setIsFocus(false)
                }}
                getOptionLabel={option => option.name}
            />
        </Wrap>
    )
}
